import { RpiTable } from "../../rpi-core/table/RpiTable";
import { GraphQL, GraphQLPagedQueryData } from "@rpi/openapi-api";
import { orderColumnsV2 } from "../../configuration/columns/ordersV2.column";
import { RpiTableV2Container, RpiTableFooter } from "../../components/RpiTableV2Container";
import React from "react";
import { RpiTableSortByProviderProps } from "../../rpi-core/table/modules/RpiTableSortBy";

type OrdersType = GraphQLPagedQueryData<GraphQL.OrdersQuery>;

export interface OrdersTableV2Props {
  orders?: OrdersType[];
  isLoading: boolean;
  error?: unknown;
  withSortBy?: Omit<RpiTableSortByProviderProps, "children"> | undefined;
}

export function OrdersTableV2({
  orders,
  isLoading,
  error,
  withSortBy,
  children,
}: React.PropsWithChildren<OrdersTableV2Props>) {
  return (
    <RpiTableV2Container data-testid="orders-table" aria-label="Orders table">
      <RpiTable
        variant="normalV2"
        withSortBy={withSortBy}
        emptyMessage={"No orders found."}
        isLoading={isLoading}
        error={error}
        perPage={orders?.length}
        data={orders}
        columns={orderColumnsV2}
      />
      {children}
    </RpiTableV2Container>
  );
}

export function OrdersTableFooter({ children }: React.PropsWithChildren) {
  return <RpiTableFooter>{children}</RpiTableFooter>;
}
